import { Link } from 'react-router-dom';
import { CheckCircle2, RotateCcw } from 'lucide-react';
import { colors } from '../../lib/theme';
import type { ScreenPhase } from '../../lib/screen-phase';

function LogoMark() {
  return (
    <div
      className="grid h-[30px] w-[30px] place-items-center rounded-[9px]"
      style={{
        background: `linear-gradient(135deg, ${colors.blue}2e, ${colors.green}2e)`,
        border: `1px solid ${colors.border}`,
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05)',
      }}
    >
      <CheckCircle2 className="h-[17px] w-[17px]" strokeWidth={2.2} style={{ color: colors.green }} />
    </div>
  );
}

type TopNavProps = {
  phase?: ScreenPhase;
  onNewScan?: () => void;
  onLogoClick?: () => void;
};

export function TopNav({ phase = 'input', onNewScan, onLogoClick }: TopNavProps) {
  const showNewScan = phase === 'results';

  return (
    <header
      className="sticky top-0 z-30 w-full backdrop-blur-md"
      style={{
        borderBottom: `1px solid ${colors.borderDark}`,
        backgroundColor: 'rgba(10,15,26,0.72)',
      }}
    >
      <div className="mx-auto max-w-page px-6 h-[62px] flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2.5"
          onClick={(e) => {
            if (onLogoClick && phase !== 'input') {
              e.preventDefault();
              onLogoClick();
            }
          }}
        >
          <LogoMark />
          <span className="text-[17px] font-bold tracking-tight" style={{ color: colors.textPrimary }}>
            EthicCheck
          </span>
          <span
            className="rounded-full px-2 py-0.5 text-[10px] font-mono tracking-wide"
            style={{
              border: `1px solid ${colors.border}`,
              color: colors.textMuted,
              backgroundColor: colors.bgTertiary,
            }}
          >
            MVP
          </span>
        </Link>
        <nav className="flex items-center gap-4 sm:gap-6 text-sm" style={{ color: colors.textSecondary }}>
          {phase === 'input' && (
            <>
              <a href="#how" className="hidden sm:inline hover:opacity-80 transition-opacity">
                How it works
              </a>
              <a href="#sources" className="hidden sm:inline hover:opacity-80 transition-opacity">
                Data sources
              </a>
            </>
          )}
          <Link to="/methodology" className="hidden sm:inline hover:opacity-80 transition-opacity">
            Methodology
          </Link>
          {showNewScan && onNewScan && (
            <button
              type="button"
              onClick={onNewScan}
              className="inline-flex items-center gap-1.5 rounded-[9px] px-3.5 py-1.5 text-[13.5px] font-semibold transition-opacity hover:opacity-90"
              style={{
                border: `1px solid ${colors.border}`,
                backgroundColor: colors.bgTertiary,
                color: colors.textPrimary,
              }}
            >
              <RotateCcw className="h-3.5 w-3.5" strokeWidth={2.2} />
              New scan
            </button>
          )}
        </nav>
      </div>
    </header>
  );
}
